module.exports = __webpack_public_path__ + "img/instagram.bd470dc0.svg";